<template>
  <v-container fluid>
    <v-tabs>
      <v-tab>Календарь</v-tab>
      <v-tab>Таблица</v-tab>
      <v-tab-item>
        <v-row>
          <v-col>
            <v-card>
              <v-card-title />
              <v-card-actions>
                <v-btn
                  class="mr-4"
                  color="grey darken-2"
                  outlined
                  @click="onSetToday"
                >
                  Сегодня
                </v-btn>
                <v-btn
                  v-if="$store.state.access[36][5]"
                  class="mr-4"
                  outlined
                  @click="onOpenDialog"
                >
                  Создать
                </v-btn>
                <v-btn
                  color="grey darken-2"
                  fab
                  small
                  text
                  @click="onPrev"
                >
                  <v-icon small>
                    mdi-chevron-left
                  </v-icon>
                </v-btn>
                <v-btn
                  color="grey darken-2"
                  fab
                  small
                  text
                  @click="onNext"
                >
                  <v-icon small>
                    mdi-chevron-right
                  </v-icon>
                </v-btn>
                <span v-if="$refs.calendar">
                  {{ $refs.calendar.title }}
                </span>
                <v-spacer />
                <!-- Type choice -->
                <v-menu
                  bottom
                  right
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-4"
                      color="grey darken-2"
                      outlined
                      v-bind="attrs"
                      v-on="on"
                    >
                      <span>{{ typeToLabel[type] }}</span>
                      <v-icon right>
                        mdi-menu-down
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="type = 'day'">
                      <v-list-item-title>День</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="type = 'week'">
                      <v-list-item-title>Неделя</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="type = 'month'">
                      <v-list-item-title>Месяц</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="type = '4day'">
                      <v-list-item-title>4 дня</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-card-actions>
              <v-card-text>
                <v-calendar
                  ref="myCalendar"
                  v-model="focus"
                  :event-color="getEventColor"
                  :events="events"
                  :short-intervals="false"
                  :type="type"
                  :weekdays="[1,2,3,4,5,6,0]"
                  locale="ru-Ru"
                  @click:event="onEvent"
                  @mousedown:time="onMouseDown"
                />
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item>
        <v-row>
          <v-col>
            <v-data-table
              :footer-props="datatable_footer"
              :headers="headers"
              :items="reminders.items"
              :options.sync="table_options"
              :server-items-length="total"
              no-data-text="Нет данных для отображения"
            >
              <template v-slot:top>
                <v-card flat>
                  <v-card-text>
                    <v-row dense>
                      <v-col
                        cols="12"
                        md="2"
                        sm="3"
                      >
                        <v-btn
                          color="primary"
                          outlined
                          @click="onOpenFilter"
                        >
                          <v-icon class="ml-3">
                            mdi-filter-variant
                          </v-icon>
                          <span class="mx-3">ФИЛЬТРЫ</span>
                        </v-btn>
                      </v-col>
                      <v-col
                        class="d-flex justify-sm-end"
                        cols="12"
                        md="5"
                        sm="5"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-if="$store.state.access[36][5]"
                              class="ma-1 pa-1"
                              color="primary"
                              v-bind="attrs"
                              v-on="on"
                              @click="onOpenDialog"
                            >
                              <v-icon class="ml-3">
                                mdi-plus
                              </v-icon>
                              <span class="md-1 mx-3">Добавить</span>
                            </v-btn>
                          </template>
                          <span>Создать новое уведомление</span>
                        </v-tooltip>
                      </v-col>
                      <v-col
                        class="d-flex justify-sm-end"
                        cols="12"
                        md="2"
                        sm="4"
                      >
                        <v-btn
                          class="ma-1 pa-1"
                          color="secondary"
                          outlined
                          @click="onDownloadReport"
                        >
                          <v-icon class="ml-3">
                            mdi-download
                          </v-icon>
                          <span class="mx-3">Выгрузить</span>
                        </v-btn>
                        <v-icon
                          class="icon-table"
                          medium
                          @click="onOpenHeader"
                        >
                          mdi-table-cog
                        </v-icon>
                      </v-col>
                    </v-row>
                    <v-row>
                      <div>
                        <v-chip
                          v-for="(filter, index) in filterStuff"
                          v-show="filter.fieldTitle !== '' "
                          :key="'i' + index"
                          close
                          @click:close="onClearFilter(filter)"
                        >
                          <span>{{ filter.fieldTitle }}</span>
                        </v-chip>
                      </div>
                    </v-row>
                  </v-card-text>
                </v-card>
              </template>
              <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
                {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
              </template>
              <template v-slot:item.actions="{ item }">
                <task-menu
                  @delete="onDeleteReminder(item)"
                  @edit="onEvent(item)"
                />
              </template>
              <template v-slot:item.dateFrom="{ item }">
                {{ formatRuDate(item.dateFrom) }}
              </template>
              <template v-slot:item.dateTo="{ item }">
                {{ formatRuDate(item.dateTo) }}
              </template>
              <template v-slot:item.updateDate="{ item }">
                {{ formatRuDate(item.updateDate) }}
              </template>
              <template v-slot:item.event="{ item }">
                {{ getEventText(item.event) }}
              </template>
              <template v-slot:item.importance="{ item }">
                <v-chip
                  :color="getImportanceColor(item.importance)"
                >
                  {{ getImportanceText(item.importance) }}
                </v-chip>
              </template>
              <template v-slot:item.status="{ item }">
                {{ getStatusText(item.status) }}
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-tab-item>
    </v-tabs>
    <v-row>
      <v-col>
        <reminder-edit
          :dialog-visible="showDialog"
          :reminder-item="reminderObj"
          :users="users"
          @close="onCloseDialog"
          @delete="onDeleteReminder"
          @save="onSaveReminder"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <filter-dialog
          :dialog-visible="filterDialogVisible"
          :filter-label="filterLabel"
          :filter-stuff="filterStuff"
          @close="onCloseFilter"
          @filter="onSetFilter"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <header-dialog
          :dialog-headers="dialogHeaders"
          :dialog-visible="headerDialogVisible"
          @close="onCloseHeader"
          @header="onSetHeader"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { format } from "date-fns-tz"
import ReminderEdit from "@/views/reminder/shared/components/reminder_edit/ReminderEdit.vue"
import { localStock } from "@/views/loyalty/shared/classes/local_stock"
import {
    getEventText,
    getImportanceColor, getImportanceText, getStatusText,
    ReminderHeadersModel,
    ReminderImportance,
    ReminderModel, ReminderTitlesModel
} from "@/views/reminder/models/reminder.model"
import { ReminderService } from "@/views/reminder/shared/services/reminder-service"
import { HeaderService } from "@/views/loyalty/shared/services/header_service"
import WebApi from "@/views/loyalty/shared/modules/web_api"
import TaskMenu from "@/views/loyalty/shared/components/task-menu/TaskMenu.vue"
import FilterDialog from "@/views/loyalty/shared/components/filter/FilterDialog.vue"
import { FilterService } from "@/views/loyalty/shared/services/filter-service"
import { clearFilter } from "@/views/loyalty/shared/classes/filter_stuff"
import HeaderDialog from "@/views/loyalty/shared/components/header/HeaderDialog.vue"
// import { reminderCsv } from "@/views/loyalty/models/reminder.model"
import { downloadCsvFile, getCsvFile } from "@/views/loyalty/shared/modules/utilities"
import { JustpayUser } from "@/views/loyalty/shared/services/justpay-user-service"
import { Userprofile } from "@/views/loyalty/shared/services/userprofile-service"

export default {
    name: "CalendarMain",
    components: { HeaderDialog, FilterDialog, TaskMenu, ReminderEdit },
    data: () => ({
        calendar_value: null,
        clientId: null,
        datatable_footer: {
            itemsPerPageText: 'Показывать по',
            pageText: 'из',
            itemsPerPageAllText: 'Все',
        },
        dialogHeaders: [],
        events: [],
        filterDialogVisible: false,
        filterLabel: 'reminder.filter',
        filterService: null,
        filterStuff: [],
        focus: '',
        headers: [
            {
                text: 'Действия',
                value: 'actions',
                sortable: false
            }
        ],
        headerDialogVisible: false,
        headerService: null,
        justpayUser: null,
        reminderObj: new ReminderModel(),
        reminders: [],
        reminderService: null,
        showDialog: false,
        table_options: {},
        total: 0,
        type: 'month',
        typeToLabel: {
            month: 'Месяц',
            week: 'Неделя',
            day: 'День',
            '4day': '4 Дня',
        },
        userId: null,
        userprofile: null,
        users: [],
        webApi: null,
    }),
    watch: {
        table_options: {
            async handler () {
                console.log(this.table_options)
                const { sortBy, sortDesc, page, itemsPerPage } = this.table_options
                this.reminders = await this.getItems()
            },
            deep: true,
        },
    },
    // TODO - create header, date's input to datepicker for dateTo and dateFrom appears in updateDate
    async beforeMount () {
        console.clear()
        this.justpayUser = new JustpayUser()
        this.reminderService = new ReminderService()
        this.filterService = new FilterService(ReminderTitlesModel)
        this.headerService = new HeaderService([...this.headers, ...ReminderHeadersModel], `${process.env.VUE_APP_NOTIF_URL}api/header/`)
        this.webApi = new WebApi().readError("Ошибка при чтении данных")
        const headers = await this.headerService.read_header('reminder', this.$store.state.client)
        this.headers = this.headerService.get_header_list(headers)

        this.userprofile = new Userprofile()
        console.log('headers', this.headers)
        this.fillFilterStuff()
    },
    async mounted () {
        console.log('this.$store.state.client', this.$store.state.client)
        // console.log('this.$store.state.client.id', this.$store.state.client.id)
        console.log('this.$store.state.user.id', this.$store.state.user.id)
        if (this.$store.state.client !== null) {
            this.clientId = this.$store.state.client.id
        } else {
            this.clientId = "0"
        }
        this.userId = this.$store.state.user.id
        console.log('calendar_value', this.calendar_value)
        console.log(new Date().getDate())
        this.reminders = await this.getItems() //  reminderService.getAll()
        console.log('mounted reminders:', this.reminders)
        console.log('this.$refs.calendar', this.$refs.myCalendar)
        if (this.reminders.items) {
            this.reminders.items.map(reminder => {
                this.addToEvents(reminder)
            })
        }
        // this.users = await this.justpayUser.getAllUsersByCustomerId(this.clientId)
        console.log('this.clientId', this.clientId)
        this.users = await this.getUsers(this.clientId)
        console.log('this.users', this.users)
        this.$refs.myCalendar.checkChange()
        console.log('this.$refs.myCalendar', this.$refs.myCalendar)
    },
    methods: {
        getStatusText,
        getEventText,
        getImportanceText,
        getImportanceColor,
        addToEvents (reminder, update) {
            const item = {
                id: reminder.id,
                name: reminder.name,
                start: this.formatDate(reminder.dateFrom),
                end: this.formatDate(reminder.dateTo),
                color: ReminderImportance[+reminder.importance].color
            }
            if (update) {
                const index = this.events.findIndex(reminder_item => reminder_item.id === reminder.id)
                console.log('index:', index)
                this.events.splice(index, 1, item)
            } else {
                this.events.push(item)
            }
            this.$refs.myCalendar.checkChange()
        },
        deleteFromEvents (reminder) {
            const index = this.reminders.items.findIndex(reminder_item => reminder_item.id === reminder.id)
            console.log('index:', index)
            this.events.splice(index, 1)
        },
        fillFilterStuff () {
            this.filterStuff = this.filterService.fillFilterStuff(ReminderTitlesModel)
            console.log('fillFilterStuff filterStuff:', this.filterStuff)
        },
        formatDate (raw_date) {
            const date = new Date(raw_date)
            // const minutes = Math.abs(date.getTimezoneOffset())
            // const local_date = add(date, { minutes: minutes })
            return format(date, "yyyy-MM-dd HH:mm:ss")
        },
        formatRuDate (raw_date) {
            // console.log('raw_date', raw_date)
            const date = new Date(raw_date)
            return format(date, "dd.MM.yyyy HH:mm")
        },
        getEventColor (event) {
            return event.color
        },
        async getItems () {
            let reminders = []
            // const reminders = await this.reminderService.getAll()
            // return reminders.map(item => this.setItems(item))
            const filterStuff = this.filterService.getFilterStuff(this.filterStuff)
            if (this.$store.state.access[36][1]) { // view all records
                reminders = await this.reminderService.getAll("", "", this.table_options.page, this.table_options.itemsPerPage, filterStuff, this.searchStuff)
                this.total = reminders.count
                return reminders
            } else if (this.$store.state.access[36][2]) { // view only own records
                reminders = await this.reminderService.getAll(this.clientId, this.userId, this.table_options.page, this.table_options.itemsPerPage, filterStuff, this.searchStuff)
                this.total = reminders.count
                return reminders
            } else {
                this.total = 0
                return reminders
            }
        },
        async getUsers (clientId) {
            const justpayusers = await this.justpayUser.getAllUsersByCustomerId(clientId)
            const userprofiles = await this.userprofile.getUserProfileListByCustomerIdAll(clientId)
            console.log('justpayusers', justpayusers)
            console.log('userprofiles', userprofiles)
            const users = [...userprofiles.items.map(item => {
                return {
                    text: `${item.UserProfileInDb.name} ${item.UserProfileInDb.patronymic} ${item.UserProfileInDb.surname}`,
                    value: item.UserProfileInDb.number ? item.UserProfileInDb.number.toString() : item.UserProfileInDb.number
                }
            }),
                ...justpayusers.filter(user => user.number).map(item => {
                // ...justpayusers.map(item => {
                    return {
                        text: `${item.name} ${item.patronymic || ''} ${item.surname}`,
                        value: item.number ? item.number.toString() : item.number
                    }
                })]
            console.log('users', users)
            return users
        },
        onClearFilter (filter) {
            console.log('filter', filter)
            const attrFilter = JSON.parse(localStorage.getItem(this.filterLabel))
            const newFilter = clearFilter(attrFilter, filter)
            console.log('newFilter', newFilter)
            localStorage.setItem(this.filterLabel, JSON.stringify(newFilter))
            this.onSetFilter()
        },
        onCloseDialog () {
            this.showDialog = false
        },
        onCloseFilter () {
            const filterStuff = JSON.parse(localStorage.getItem(this.filterLabel))
            console.log('const filterStuff', filterStuff)
            this.filterStuff = filterStuff || this.fillFilterStuff()
            console.log('onCloseFilter this.filterStuff', this.filterStuff)
            this.filterDialogVisible = false
        },
        onCloseHeader () {
            this.headerDialogVisible = false
        },
        onDate (event) {
            console.log('onDate', event)
            // let dateFrom = new Date().setDate(event.day)
            // dateFrom = new Date(dateFrom).setMonth(event.month - 1)
            this.showDialog = true
            this.reminderObj = new ReminderModel({
                dateFrom: new Date(event.year, event.month - 1, event.day, 0, 0, 0),
                dateTo: new Date(event.year, event.month - 1, event.day, 23, 59, 59)
            })
        },
        async onDeleteReminder (reminder) {
            const result = await this.reminderService.deleteReminder(reminder.id)
            console.log('delete result:', result)
            if (result) {
                this.deleteFromEvents(reminder)
            }
            this.reminders = await this.getItems()
            this.showDialog = false
        },
        onDownloadReport () {
            console.log("reminder", this.reminders)
            // let csv = reminderCsv
            // csv += getCsvFile(this.reminders)
            // console.log("csv", csv)
            // downloadCsvFile("ReminderReport", csv)
        },
        async onEvent (event) {
            console.log('onEvent', event)
            console.log('event', event.event)
            const id = Object.hasOwn(event.event, 'id') ? event.event.id : event.id
            const reminderObj = await this.reminderService.getById(id)
            console.log('const reminderObj:', this.reminderObj)
            this.reminderObj = new ReminderModel(reminderObj)
            console.log('reminderObj:', this.reminderObj)
            this.showDialog = true
        },
        onMouseDown (event) {
            console.log('onMouseDown event:', event)
        },
        onNext () {
            this.$refs.myCalendar.next()
        },
        onOpenDialog () {
            this.showDialog = true
            this.reminderObj = new ReminderModel()
        },
        onOpenFilter () {
            this.filterDialogVisible = true
        },
        async onOpenHeader () {
            this.headerDialogVisible = true
            const data = await this.headerService.read_header('reminder', this.$store.state.client)
            this.dialogHeaders = this.headerService.get_header(data)
        },
        onPrev () {
            this.$refs.myCalendar.prev()
        },
        async onSaveReminder (reminder) {
            console.log('reminder', reminder)
            if (!reminder.id) {
                const reminderObj = await this.reminderService.createReminder(new ReminderModel(reminder))
                console.log('const reminder', reminderObj)
                this.reminderObj = new ReminderModel(reminderObj)
                this.addToEvents(reminderObj)
                console.log('new_reminder', this.reminderObj)
            } else {
                const update_reminder = await this.reminderService.updateReminder(reminder)
                this.reminderObj = new ReminderModel(update_reminder)
                console.log('update_reminder', update_reminder)
                console.log('this.reminderObj', this.reminderObj)
                this.addToEvents(update_reminder, true)
            }

            console.log('reminders:', this.reminders)
            console.log('this.events:', this.events)
            this.reminders = await this.getItems()
            this.showDialog = false
        },
        async onSetFilter () {
            this.filterStuff = JSON.parse(localStorage.getItem(this.filterLabel)) || ''
            this.filterDialogVisible = false
            console.log('this.filterStuff', this.filterStuff)
            this.reminders = await this.getItems()
            console.log('this.reminders', this.reminders)
        },
        async onSetHeader (value) {
            console.log('onSetHeader', value)
            this.dialogHeaders = value
            this.headerDialogVisible = false
            const data = await this.headerService.set_header("reminder", this.$store.state.client ? this.$store.state.client.id : "0", value)
            console.log('headers', data)
            await this.headerService.create_header(data)
            this.headers = this.headerService.get_header_list(data)
        },
        onSetToday () {
            this.focus = ''
        },
        setItems (data) {
            return Reflect.construct(ReminderModel, [data])
        }

    }
}
</script>

<style scoped>

</style>
